"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var serializr_1 = require("serializr");
var types_1 = require("./types");
var Comment_1 = require("./Comment");
var Attachment_1 = require("./Attachment");
var Reactions_1 = require("./Reactions");
var FeedItemEntity = /** @class */ (function () {
    function FeedItemEntity() {
    }
    tslib_1.__decorate([
        serializr_1.serializable(serializr_1.object(types_1.SocialText))
    ], FeedItemEntity.prototype, "body", void 0);
    return FeedItemEntity;
}());
var FeedItemPin = /** @class */ (function () {
    function FeedItemPin() {
    }
    tslib_1.__decorate([
        serializr_1.serializable
    ], FeedItemPin.prototype, "since", void 0);
    tslib_1.__decorate([
        serializr_1.serializable
    ], FeedItemPin.prototype, "pinnedBy", void 0);
    return FeedItemPin;
}());
var FeedItemRequester = /** @class */ (function () {
    function FeedItemRequester() {
    }
    tslib_1.__decorate([
        serializr_1.serializable
    ], FeedItemRequester.prototype, "subscribed", void 0);
    return FeedItemRequester;
}());
var FeedItemComments = /** @class */ (function () {
    function FeedItemComments(comments) {
        this.comments = [];
        this.total = 0;
        this.total = comments.total;
        this.comments = comments.comments.map(function (comment) { return new Comment_1.Comment(comment); });
        this.contextToken = comments.contextToken;
    }
    FeedItemComments.prototype.add = function (comment) {
        this.comments.push(new Comment_1.Comment(comment));
        this.total++;
    };
    tslib_1.__decorate([
        serializr_1.serializable(serializr_1.list(serializr_1.object(Comment_1.Comment))),
        mobx_1.observable.shallow
    ], FeedItemComments.prototype, "comments", void 0);
    tslib_1.__decorate([
        mobx_1.observable,
        serializr_1.serializable
    ], FeedItemComments.prototype, "total", void 0);
    tslib_1.__decorate([
        serializr_1.serializable
    ], FeedItemComments.prototype, "contextToken", void 0);
    return FeedItemComments;
}());
var FeedItem = /** @class */ (function () {
    function FeedItem(feedItem, repository) {
        this.repository = repository;
        this.attachments = [];
        this.react = mobx_1.flow(function (reaction) {
            var response, error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.repository.reactions.react({
                                itemId: this.feedItemId,
                                reaction: reaction,
                            })];
                    case 1:
                        response = _a.sent();
                        this.reactions = new Reactions_1.Reactions(response.data);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error('FeedItem react error: ', error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
        this.unreact = mobx_1.flow(function (reactionCode) {
            var response, error_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.repository.reactions.unreact({
                                itemId: this.feedItemId,
                                reactionCode: reactionCode,
                            })];
                    case 1:
                        response = _a.sent();
                        this.reactions = new Reactions_1.Reactions(response.data);
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        console.error('FeedItem unreact error: ', error_2);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
        this.comment = mobx_1.flow(function (comment) {
            var response, error_3;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.repository.comments.create({
                                entityId: this.feedItemId,
                                comment: comment,
                            })];
                    case 1:
                        response = _a.sent();
                        this.comments.add(response.data.comment);
                        return [3 /*break*/, 3];
                    case 2:
                        error_3 = _a.sent();
                        console.error('FeedItem comment error: ', error_3);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
        this.feedItemId = feedItem.feedItemId;
        this.createdAt = feedItem.createdAt;
        this.createdBy = feedItem.createdBy;
        this.entity = feedItem.entity;
        this.comments = new FeedItemComments(feedItem.comments);
        this.reactions = new Reactions_1.Reactions(feedItem.reactions);
        this.attachments = (feedItem.entity.attachments || []).map(function (attachment) { return new Attachment_1.Attachment(attachment); });
        this.pin = feedItem.pin;
        this.requesterContext = feedItem.requesterContext;
    }
    tslib_1.__decorate([
        serializr_1.serializable
    ], FeedItem.prototype, "feedItemId", void 0);
    tslib_1.__decorate([
        serializr_1.serializable
    ], FeedItem.prototype, "createdAt", void 0);
    tslib_1.__decorate([
        serializr_1.serializable
    ], FeedItem.prototype, "createdBy", void 0);
    tslib_1.__decorate([
        serializr_1.serializable(serializr_1.object(FeedItemEntity))
    ], FeedItem.prototype, "entity", void 0);
    tslib_1.__decorate([
        serializr_1.serializable(serializr_1.object(FeedItemComments))
    ], FeedItem.prototype, "comments", void 0);
    tslib_1.__decorate([
        serializr_1.serializable(serializr_1.object(Reactions_1.Reactions)),
        mobx_1.observable
    ], FeedItem.prototype, "reactions", void 0);
    tslib_1.__decorate([
        serializr_1.serializable(serializr_1.list(serializr_1.object(Attachment_1.Attachment))),
        mobx_1.observable.shallow
    ], FeedItem.prototype, "attachments", void 0);
    tslib_1.__decorate([
        serializr_1.serializable(serializr_1.object(FeedItemPin)),
        mobx_1.observable
    ], FeedItem.prototype, "pin", void 0);
    tslib_1.__decorate([
        serializr_1.serializable(serializr_1.object(FeedItemRequester)),
        mobx_1.observable
    ], FeedItem.prototype, "requesterContext", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], FeedItem.prototype, "react", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], FeedItem.prototype, "unreact", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], FeedItem.prototype, "comment", void 0);
    return FeedItem;
}());
exports.FeedItem = FeedItem;
//# sourceMappingURL=FeedItem.js.map